// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { observable, action, makeAutoObservable } from "mobx";
import { FavLine } from "../models/FavLine.model";
import { FavStop } from "../models/FavStop.model";
import { MyTibApi } from "../api/my-tib.api";
import { SictmApi } from "../api/sictm.api";
import { SaepApi } from "../api/saep.api";
import { setEntities } from "../utils/parsers";

export default class MyTIBStore {
  stops: Array<FavStop> = [];
  lines: Array<FavLine> = [];

  @observable loadingLines: boolean = false;
  @observable loadingStops: boolean = false;
  @observable favLines: Array<any> = [];
  @observable favStops: Array<any> = [];
  @observable settings: any;
  @observable profile: any = {};
  @observable nextHours: Array<any> = [];
  @observable version: string = "";
  @observable allStops: Array<any> = [];
  @observable allLines: Array<any> = [];

   constructor() {
    makeAutoObservable(this);
  }

  @action getFavLines = async (favLineId?: number) => {
    this.loadingLines = true;
    try {

      this.lines = await MyTibApi.getFavLines();

      if (this.lines.length > this.favLines.length) {

        const favLineIds = this.favLines.map((x) => x.lineId);
        const arrayNewFavLines = this.lines.filter((x) => !favLineIds.includes(x.lineId));

        await Promise.all(

            arrayNewFavLines.map(async (line: FavLine) => {

              try {

                const lineName = await SictmApi.getLineById(line.lineId);

                if (lineName !== undefined) {

                  this.favLines.push({
                    code: lineName.cod,
                    name: lineName.nam,
                    lineId: line.lineId,
                    notifications: line.notifications,
                  });
                }
              } catch (error) {
                console.warn("cannot get fav line ", error);
              }
            })
        );
        this.favLines = this.favLines.filter(value => Object.keys(value).length !== 0);
      }

      if (this.lines.length <= this.favLines.length) {
        const lineIds = this.lines.map((x) => x.lineId);
        this.favLines = this.favLines.filter((x) => lineIds.includes(x.lineId) && Object.keys(x).length !== 0);
      }

      if (favLineId) {
        this.favLines = this.favLines.map((x) => {
          if (x.lineId === favLineId) x.notifications = !x.notifications;
          return x;
        });
      }

      this.favLines = this.favLines.sort((a, b) => a.code - b.code);
      this.loadingLines = false;
    } catch (error) {
      this.loadingLines = false;
    }
  };

  @action getAllLines = async (search?: string, all?: boolean) => {
    const query = search?.toLowerCase();
    let res = await SictmApi.getAllLines(all);
    if (search) {
      res = res.filter(
          (el: any) =>
              el.cod.includes(query) || el.nam.toLowerCase().includes(query)
      );
    }
    this.allLines = await Promise.all(
        res.map(async (l: any) => {
          const exists = this.lines.findIndex(
              (line: any) => line.lineId === l.id
          );

          return {
            id: l.id,
            cod: l.cod,
            nam: l.nam,
            added: exists !== -1,
          };
        })
    );
  };

  @action getFavStops = async (favStopId?: number) => {
    this.loadingStops = true;

    try {

      this.stops = await MyTibApi.getFavStops();

      if (this.stops.length > this.favStops.length) {

        const favStopIds = this.favStops.map((x) => x.stopId);
        const arrayNewFavStops = this.stops.filter((x) => !favStopIds.includes(x.stopId));

        let curIsland = "ctmr4";
        if (this.settings !== undefined && this.settings.island !== null && this.settings.island !== "") {
          curIsland = this.settings.island;
        }

        await Promise.all(

            arrayNewFavStops.map(async (stop: FavStop) => {

              try {

                const stopName = await SictmApi.getStopById(stop.stopId);

                const resStopDepartures = await SaepApi.getNextDeparturesByCode(stopName.cod, curIsland);

                if (resStopDepartures !== undefined && resStopDepartures.length > 0) {

                  this.nextHours.push({
                    id: stop.stopId,
                    stop: `${stopName.cod} - ${stopName.nam}`,
                    hours: resStopDepartures,
                  });
                }

                this.favStops.push({
                  stopId: stop.stopId,
                  code: stopName.cod,
                  name: stopName.nam,
                  notifications: stop.notifications,
                });

              } catch (error) {
                console.warn("cannot get fav stop next departures", error);
              }
            })
        );
      }

      if (this.stops.length < this.favStops.length) {
        const stopIds = this.stops.map((x) => x.stopId);
        this.favStops = this.favStops.filter((x) => stopIds.includes(x.stopId));
      }

      if (favStopId) {
        this.favStops = this.favStops.map((x) => {
          if (x.stopId === favStopId) x.notifications = !x.notifications;
          return x;
        });
      }

      this.favStops = this.favStops.sort((a, b) => a.code - b.code)
      this.loadingStops = false;
    } catch (error) {
      this.loadingStops = false;
    }
  };

  // @action getNextHours = async () => {
  //   await Promise.all(
  //     this.stops.map(async (stop: FavStop) => {
  //       const stopName = await SictmApi.getStopById(stop.stopId);
  //       const next = await SictmApi.getNextStops(stop.stopId);
  //       const exists = this.nextHours.findIndex(
  //         (e) => e.stop === `${stopName.cod} - ${stopName.nam}`
  //       );
  //       if (exists === -1) {
  //         this.nextHours.push({
  //           stop: `${stopName.cod} - ${stopName.nam}`,
  //           hours: next,
  //         });
  //       }
  //     })
  //   );
  // };

  @action getAllStops = async (search?: string) => {
    const res = await SictmApi.getAllStops(search);

    try {
      this.allStops = await Promise.all(
          res.map(async (s: any) => {
            const exists = this.stops.findIndex(
                (stop: any) => stop.stopId === s.id
            );

            return {
              id: s.id,
              cod: s.cod,
              nam: s.nam,
              added: exists !== -1,
            };
          })
      );
    } catch (err) { }

  };

  getAlertsLines = () => {
    return this.favLines.filter((e) => e.notifications).length;
  };

  getAlertsStops = () => {
    return this.favStops.filter((e) => e.notifications).length;
  };

  @action getSettings = async () => {
    this.settings = await MyTibApi.getSettings();
    let curIsland = "ctmr4";
    if (this.settings.island !== null && this.settings.island !== "") {
      curIsland = this.settings.island;
    }
    setEntities(curIsland);
  };

  @action getMyProfile = async () => {
    this.profile = await MyTibApi.getMyProfile();
  };

  @action addLine = async (id: number) => {
    await MyTibApi.addFavLine(id);
    this.getFavLines();
  };

  @action addStop = async (id: number) => {
    await MyTibApi.addFavStop(id);
    this.getFavStops();
  };

  @action removeLine = async (id: number) => {
    await MyTibApi.deleteFavLine(id);
    this.getFavLines();
  };

  @action removeStop = async (id: number) => {
    await MyTibApi.deleteFavStop(id);
    const index = this.nextHours.findIndex((e: any) => e.id === id);
    this.nextHours.splice(index, 1);
    this.getFavStops();
  };

  @action updateLine = async (id: number, active: boolean) => {
    await MyTibApi.updateFavLine(id, active);
    const favLineId = id;
    this.getFavLines(favLineId);
  };

  @action updateStop = async (id: number, active: boolean) => {
    await MyTibApi.updateFavStop(id, active);
    const favStopId = id;
    this.getFavStops(favStopId);
  };

  @action updateSettings = async (settings: any) => {
    await MyTibApi.updateSettings(settings);
    this.getSettings();
  };

  @action updateStudentProfile = async (settings: any) => {
    await MyTibApi.updateStudentProfile(settings);
    this.getSettings();
  };

  /**
   * Descarga el informe PDF del historial del usuario
   * @returns Blob del PDF o undefined si falla
   */
  @action getUserHistoryReport = async (): Promise<Blob | undefined> => {
    try {
      const pdfBlob = await MyTibApi.getUserHistoryReport();
      
      if (!pdfBlob) {
        console.warn("No PDF data received");
        return undefined;
      }

      return pdfBlob;
    } catch (error) {
      console.error("Error in getUserHistoryReport:", error);
      return undefined;
    }
  };
}